import React from 'react';
import './Cucuta.css'; 

const Marandua = () => {
  return (
    <div>
     <div className='Espacio-titulo'>
     <h1><p className='Titulo'>Base aérea Marandua</p></h1>
     </div>
 
     <div className='containeraeropuertos'>
       
       <div className='subcontainerCUC'>
         <h1>SID</h1>
         <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
           <tr className='divisoraeropuertos1'>
               <th className="pista">PISTA 08</th>                      
           </tr>  
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/TIDS1B.pdf" target="_blank" rel="noreferrer">TIDS1B</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/TIDS1B.pdf" target="_blank" rel="noreferrer">LUTVB</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/TIDS1B.pdf" target="_blank" rel="noreferrer">AMVO1B</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/TIDS1B.pdf" target="_blank" rel="noreferrer">KUBT1A</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/TIDS1B.pdf" target="_blank" rel="noreferrer">OVTU1B</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1F.pdf" target="_blank" rel="noreferrer">AMVO1F</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1F.pdf" target="_blank" rel="noreferrer">LUTV1F</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1F.pdf" target="_blank" rel="noreferrer">OVTU1D</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1F.pdf" target="_blank" rel="noreferrer">TIDS1F</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1F.pdf" target="_blank" rel="noreferrer">UMBE1F</a></th>
           </tr>
          
           </table>
           <table className='tabla-aeropuertos2'>
           <tr className='divisoraeropuertos1'>
               <th className="pista">PISTA 26</th>                      
           </tr>           
         
           </table>
         </div> 
       </div>
 
       <div className='subcontainerCUC'>
         <h1>STAR</h1>
         <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
           <tr className='divisoraeropuertos2'>
               <th className="pista">PISTA 08</th>                      
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1D.pdf" target="_blank" rel="noreferrer">AMVO1D</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1D.pdf" target="_blank" rel="noreferrer">LUTV1D</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1D.pdf" target="_blank" rel="noreferrer">OVTU1C</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1D.pdf" target="_blank" rel="noreferrer">TIDS1D</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1D.pdf" target="_blank" rel="noreferrer">UMBET1E</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1D.pdf" target="_blank" rel="noreferrer">AMVO1E</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1D.pdf" target="_blank" rel="noreferrer">LUTV1R</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1D.pdf" target="_blank" rel="noreferrer">OVTU1E</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1D.pdf" target="_blank" rel="noreferrer">TIDS1E</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/AMVO1D.pdf" target="_blank" rel="noreferrer">UMBE1G</a></th>
           </tr>
           
           
           </table>
 
           <table className='tabla-aeropuertos2'>
           <tr className='divisoraeropuertos2'>
               <th className="pista">PISTA 26</th>                      
           </tr>
           
           </table>
         </div> 
       </div>
 
       <div className='subcontainerCUC'>
         <h1>IAC</h1>
         <div className='container-tablas'>
            <table className='tabla-aeropuertos1'>
           <tr className='divisoraeropuertos3'>
               <th className="pista">PISTA 08</th>                      
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/ILSY08.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/ILSY08.pdf" target="_blank" rel="noreferrer">LOC Y</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/ILSZ08.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/ILSZ08.pdf" target="_blank" rel="noreferrer">LOC Z</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/ILSX08.pdf" target="_blank" rel="noreferrer">ILS X</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/RNP08.pdf" target="_blank" rel="noreferrer">RNP</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/VORZ08.pdf" target="_blank" rel="noreferrer">VOR Z</a></th>
           </tr>
          
           
           
           </table>
           <table className='tabla-aeropuertos2'>
           <tr className='divisoraeropuertos3'>
               <th className="pista">PISTA 26</th>                      
           </tr> 
           
           </table>
         </div>
       </div>
 
     </div>
 
     <div className='containeraeropuertos'>
       
       <div className='subcontainerCUC'>
         <h1>SID</h1>
         <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
           <tr className='divisoraeropuertos1'>
               <th className="pista">PISTA 03</th>                      
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/TIDS1C.pdf" target="_blank" rel="noreferrer">TIDS1C</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/TIDS1C.pdf" target="_blank" rel="noreferrer">OVTU1A</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/TIDS1C.pdf" target="_blank" rel="noreferrer">LUTV1C</a></th>
           </tr>
           <tr>
             <th className='Procedimientos'><a href="/regionales/SKUA/TIDS1C.pdf" target="_blank" rel="noreferrer">AMVO1C</a></th>
           </tr>
           
           </table>
           <table className='tabla-aeropuertos2'>
           <tr className='divisoraeropuertos1'>
               <th className="pista">PISTA 21</th>                      
           </tr>
           
           </table>
         </div> 
       </div>
 
       <div className='subcontainerCUC'>
         <h1>STAR</h1>
         <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
           <tr className='divisoraeropuertos2'>
               <th className="pista">PISTA 03</th>                      
           </tr>
           

           </table>
 
           <table className='tabla-aeropuertos2'>
           <tr className='divisoraeropuertos2'>
               <th className="pista">PISTA 21</th>                      
           </tr>
         
           </table>
         </div> 
       </div>
 
       <div className='subcontainerCUC'>
         <h1>IAC</h1>
         <div className='container-tablas'>
            <table className='tabla-aeropuertos1'>
           <tr className='divisoraeropuertos3'>
               <th className="pista">PISTA 03</th>                      
           </tr>
           
           
           </table>
           <table className='tabla-aeropuertos2'>
           <tr className='divisoraeropuertos3'>
               <th className="pista">PISTA 21</th>                      
           </tr> 
          
           
           </table>
         </div>
       </div>
 
     </div>
 
   </div>
   );
};
export default Marandua;